"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfig = exports.loadConfig = exports.ConfigProvider = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
// @ts-ignore
const toml_j0_4_1 = __importDefault(require("toml-j0.4"));
const Spinner_1 = require("../components/spinner/Spinner");
const Config_1 = require("../models/config/Config");
const ConfigContext = (0, react_1.createContext)(undefined);
/**
 * Loads the configuration and provides it via context.
 */
const ConfigProvider = (props) => {
    const { tenantId } = (0, react_router_dom_1.useParams)();
    const [config, setConfig] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    /** On first render load the config file. */
    (0, react_1.useEffect)(() => {
        async function fetchConfig() {
            try {
                if (!tenantId) {
                    throw new Error("No tenantId provided in url parameters.");
                }
                const config = await loadConfig(tenantId);
                setConfig(config);
            }
            catch (error) {
                setError(error);
            }
        }
        fetchConfig();
    }, []); // [] means it only runs once.
    if (error) {
        throw error;
    }
    if (config) {
        return (react_1.default.createElement(ConfigContext.Provider, { value: config }, props.children));
    }
    else {
        return react_1.default.createElement(Spinner_1.Spinner, { className: "my-3 mx-auto" });
    }
};
exports.ConfigProvider = ConfigProvider;
async function loadConfig(tenantId) {
    const configFile = await fetch(`/${tenantId}/config.toml`);
    if (!configFile.ok) {
        throw new Error(`Failed to load config file: tenant=${tenantId}, status=${configFile.status} ${configFile.statusText}`);
    }
    const configJson = toml_j0_4_1.default.parse(await configFile.text());
    return Config_1.Config.fromJSON(configJson);
}
exports.loadConfig = loadConfig;
/**
 * Returns the config context.
 */
function useConfig() {
    const context = (0, react_1.useContext)(ConfigContext);
    if (context === undefined) {
        throw new Error("useConfig must be used within a ConfigProvider");
    }
    return context;
}
exports.useConfig = useConfig;
